module.exports = __webpack_public_path__ + "static/images/styles/images/nations/poland.b602e625.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/poland.png
// module id = 3670
// module chunks = 11